import { useState } from "react";
import { api, formatApiErrorDetail, API_BASE } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import PasswordInput from "@/components/PasswordInput";

export default function ForcePasswordChange() {
  const { user, refresh } = useAuth();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const submit = async (e) => {
    e.preventDefault(); setErr("");
    if (pw !== pw2) { setErr("Passwords do not match."); return; }
    if (pw.length < 8) { setErr("Password must be at least 8 characters."); return; }
    setBusy(true);
    try {
      await api.post("/auth/set-initial-password", { new_password: pw });
      await refresh();
    } catch (e) { setErr(formatApiErrorDetail(e.response?.data?.detail) || e.message); }
    finally { setBusy(false); }
  };
  const first = (user?.name || "").split(" ")[0] || "there";
  return (
    <div className="min-h-screen bg-slate-100 flex items-start justify-center p-4 pt-10">
      <form onSubmit={submit} className="w-full max-w-md bg-white p-8 rounded-md border border-slate-200 shadow-sm" data-testid="force-password-form">
        <div className="flex flex-col items-center mb-5">
          <img src={`${API_BASE}/settings/company/logo`} alt="SOS" className="h-14 w-14 rounded-md object-contain" />
          <div className="font-black text-xl mt-2">Safety Onsite Solutions</div>
        </div>
        <h1 className="text-2xl font-black">Set your own password</h1>
        <p className="mt-2 text-sm text-slate-600">
          Hi {first} — you signed in with a temporary password. Pick your own password now
          (at least 8 characters). You'll use it every time you sign in from here on.
        </p>
        <label className="block text-sm font-semibold text-slate-700 mt-5">New password</label>
        <PasswordInput required value={pw} onChange={(e) => setPw(e.target.value)}
          data-testid="force-password-new" autoComplete="new-password" wrapperClassName="mt-1"
          className="w-full h-12 px-3 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500" />
        <label className="block text-sm font-semibold text-slate-700 mt-4">Confirm new password</label>
        <PasswordInput required value={pw2} onChange={(e) => setPw2(e.target.value)}
          data-testid="force-password-confirm" autoComplete="new-password" wrapperClassName="mt-1"
          className="w-full h-12 px-3 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500" />
        {err && <div className="mt-3 text-sm text-red-600" data-testid="force-password-error">{err}</div>}
        <button data-testid="force-password-submit" disabled={busy}
          className="mt-6 w-full h-12 bg-green-600 hover:bg-green-700 text-white font-bold rounded-md disabled:opacity-60">
          {busy ? "Saving…" : "Save password & continue"}
        </button>
      </form>
    </div>
  );
}
